<template>
  <div>
    <div class="table-container" style="padding: 0">
      <!-- 基本信息 -->
      <TableCommon title="基本信息" :show-custome="false">
        <div class="form-container" style="padding: 0">
          <el-form inline size="mini" label-width="100px" :model="wlyClientPo">
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="客户编码">
                  <el-input v-model="wlyClientPo.PARTNER" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="客户名称">
                  <el-input v-model="wlyClientPo.NAME_ORG1" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="客户类型">
                  <el-select
                    v-model="wlyClientPo.ZZFLD000016"
                    placeholder="请选择"
                    type="select"
                    clearable
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                  >
                    <el-option
                      v-for="item in selectDataOptions['A0009']"
                      :key="item.value"
                      :value="item.value"
                      :label="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="法人姓名">
                  <el-input
                    v-model="wlyClientPo.ZZFLD000018"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    placeholder="请输入"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="法人电话">
                  <el-input
                    v-model="wlyClientPo.ZZFLD000019"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    placeholder="请输入"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="营销管理编码">
                  <el-input v-model="wlyClientPo.ZZFLD00001C" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="旧编码">
                  <el-input v-model="wlyClientPo.ZZFLD000017" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="变更自客户">
                  <wly-input
                    v-model="wlyClientPo.ZZFLD00001D"
                    input-type="customer"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    @enter="handleEnter(...arguments)"
                    @handleSuffixClick="openDialog($event, '客户选择', 1)"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="变更客户描述">
                  <wly-input
                    v-model="wlyClientPo.NAME_ORG2"
                    input-type="customer"
                    disabled-enter
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    @handleSuffixClick="openDialog($event, '客户选择', 1)"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="税号">
                  <el-input v-model="TAX.TAXNUMXL" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="发票类型">
                  <el-select v-model="TAX.TAXTYPE" :disabled="!$_has(['WLY004', 'WLYALL'])">
                    <el-option
                      v-for="item in selectDataOptions['A0032']"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="工商登记号">
                  <el-input v-model="wlyClientPo.ZZFLD00001B" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="创建人">
                  <el-input v-model="wlyClientPo.CRUSR_NAME" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="创建日期">
                  <el-input v-model="wlyClientPo.CRDAT" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="渠道类型">
                  <el-select v-model="wlyClientPo.ZZCUSTCHAL" :disabled="!$_has('WLY004')&&!$_has('WLYALL')">
                    <el-option
                      v-for="item in selectDataOptions['A0064']"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="更改人">
                  <el-input v-model="wlyClientPo.CHUSR_NAME" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="更改日期">
                  <el-input v-model="wlyClientPo.CHDAT" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="终止协议">
                  <el-checkbox v-model="wlyClientPo.ZZXY" :disabled="!$_has('WLY004')" true-label="X" false-label="">是</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="归档标识" class="crchive">
                  <el-checkbox
                    v-model="wlyClientPo.ZZFLD000026"
                    true-label="X"
                    false-label=""
                    :disabled="!$_has('WLY004')"
                    @change="radioChange($event, 1)"
                  >已归档</el-checkbox>
                  <el-checkbox
                    v-model="wlyClientPo.ZZFLD00009N"
                    true-label="X"
                    false-label=""
                    :disabled="!hasRole"
                  >已停止未归档</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="归档日期" class="crchive">
                  <el-input v-model="wlyClientPo.ZZFLD000026_DATE" disabled size="mini" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="归档备注" class="crchive">
                  <el-input v-model="wlyClientPo.REMARK_GD" :disabled="!$_has('WLY004')" size="mini" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="是否停用">
                  <el-checkbox
                    v-model="wlyClientPo.BLOCK"
                    true-label="X"
                    false-label=""
                    :disabled="!$_has('WLY004')"
                    @change="radioChange($event, 2)"
                    >是</el-checkbox
                  >
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="停用日期">
                  <el-input v-model="wlyClientPo.BLOCK_DATE" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="停用备注">
                  <el-input v-model="wlyClientPo.REMARK_BLK" :disabled="!$_has('WLY004')" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="合作中">
                  <el-checkbox
                    v-model="wlyClientPo.COOPERATION"
                    true-label="X"
                    false-label=""
                    :disabled="!$_has(['WLY004', 'WLY008'])"
                    >是</el-checkbox
                  >
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="实际控制人">
                  <el-input v-model="wlyClientPo.ZSJKZ_PL" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="控制人电话">
                  <el-input v-model="wlyClientPo.ZSJKZ_TL" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="社会信用代码" class="line-16">
                  <el-input v-model="wlyClientPo.ZZFLD00001A" :disabled="!$_has(['WLY004', 'WLYALL'])" />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="业务负责人">
                  <el-input v-model="wlyClientPo.ZYWFZ_PL" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="负责人电话">
                  <el-input v-model="wlyClientPo.ZYWFZ_TL" disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="片区">
                  <el-select
                    v-model="wlyClientPo.PQ_REGION"
                    placeholder="请选择片区"
                    clearable
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                  >
                    <el-option
                      v-for="item in selectDataOptions.A0085"
                      :key="item.value"
                      :label="item.name"
                      :value="item.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="上级客户编码">
                  <wly-input
                    ref="superiorBpInput"
                    :key="`superior-bp-${wlyClientPo.SUPERIOR_BP || 'empty'}`"
                    v-model="wlyClientPo.SUPERIOR_BP"
                    input-type="customer"
                    clearable
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    @enter="handleSuperiorClientEnter"
                    @handleSuffixClick="openSuperiorClientDialog"
                    @input="handleSuperiorClientInput"
                    @clear="handleSuperiorClientClear"
                    @keydown.native="handleSuperiorClientKeydown"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="上级客户名称">
                  <el-input v-model="wlyClientPo.SUPERIOR_BP_NAME" placeholder="系统自动代入" disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="曾用名编码">
                  <wly-input
                    ref="formerBpInput"
                    :key="`former-bp-${wlyClientPo.FORMER_BP || 'empty'}`"
                    v-model="wlyClientPo.FORMER_BP"
                    input-type="customer"
                    clearable
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    @enter="handleFormerClientEnter"
                    @handleSuffixClick="openFormerClientDialog"
                    @input="handleFormerClientInput"
                    @clear="handleFormerClientClear"
                    @keydown.native="handleFormerClientKeydown"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="曾用名名称">
                  <el-input v-model="wlyClientPo.FORMER_BP_NAME" placeholder="系统自动代入" disabled />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="历史创建日期">
                  <el-input v-model="wlyClientPo.ZZFLD00003D" disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="主体公司">
                  <el-input
                    v-model="wlyClientPo.ZMAIN_COMPANY"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="是否专卖店赋能">
                  <el-checkbox
                    v-model="wlyClientPo.ZMD_EMPOWER"
                    true-label="X"
                    false-label=""
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                  >是</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :lg="8" :md="12">
                <el-form-item label="备注">
                  <el-input
                    v-model="wlyClientPo.ZZFLD00008R"
                    resize="none"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    type="textarea"
                    rows="3"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="备注1">
                  <el-input
                    v-model="wlyClientPo.ZZFLD00008S"
                    resize="none"
                    :disabled="!$_has(['WLY004', 'WLYALL'])"
                    type="textarea"
                    rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </TableCommon>

      <!-- 银行信息 -->
      <slot name="bank" />

      <!-- 营销单元 -->
      <TableCommon title="营销单元" :custome-config="() => vxeShowCustom('xTableSaleCenter')">
        <template #button v-if="$_has(['WLY004', 'WLYALL'])">
          <table-button name="add" tip="增加" @click="insertSaleCenter" />
          <table-button name="delete" tip="删除" @click="removeSaleCenter" />
        </template>
        <vxe-grid
          ref="xTableSaleCenter"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="saleCenterGridOptions.columns"
          :data="saleCenterGridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in saleCenterGridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <template v-if="item.field === 'ZZFLD00001H'">
                <el-select
                  v-model="row[item.field]"
                  size="mini"
                  :disabled="!$_has(['WLY004', 'WLYALL'])"
                  @change="changeColums($event, row)"
                >
                  <el-option
                    v-for="items in selectDataOptions['orgList']"
                    :key="items.SOBID"
                    :value="items.SOBID"
                    :label="items.MC_SHORT"
                  />
                </el-select>
              </template>
              <template v-else>
                <el-select v-model="row[item.field]" size="mini" :disabled="!$_has(['WLY004', 'WLYALL'])">
                  <el-option
                    v-for="items in row.baseList"
                    :key="items.SOBID"
                    :value="items.SOBID"
                    :label="items.MC_SHORT"
                  />
                </el-select>
              </template>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <!-- 地址信息 -->
      <TableCommon title="地址信息" :custome-config="() => vxeShowCustom('xTable3')">
        <template v-if="$_has(['WLYALL', 'WLY004'])" #button>
          <table-button name="export" tip="导出" @click="exportAddressExcel" />
          <table-button name="add" tip="增加" @click="insertAddressList" />
          <table-button name="delete" tip="删除" @click="removeAddressList" />
          <table-button name="export" tip="打印" @click="printAddress" />
        </template>
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="mini"
          :edit-rules="validRules"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :columns="gridOptions3.columns"
          :data="gridOptions3.data"
          @edit-actived="editActived"
        >
          <template #ADR_KIND="{row}">
            <span>{{ row.ADR_KIND_TEXT }}</span>
          </template>
          <template #REGION="{row}">
            <span>{{ row.BEZEI }}</span>
          </template>
          <template #CITY_CODE="{ row }">
            <span>{{ row.CITY_NAME }}</span>
          </template>
          <template #STREETCODE="{row}">
            <span>{{ row.STREET_NAME }}</span>
          </template>

          <template #ADR_KIND_edit="{row}">
            <vxe-select
              v-model="row.ADR_KIND"
              :disabled="row.GUID ? true : false"
              type="text"
              size="mini"
              transfer
              @change="addressTypeChange($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['A0099']"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value"
              />
            </vxe-select>
          </template>
          <template #C_O_NAME_edit="{row, rowIndex}">
            <el-input
              v-model="row.C_O_NAME"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'C_O_NAME', row, rowIndex)"
            />
          </template>
          <template #BUILDING_edit="{row, rowIndex}">
            <el-input
              v-model="row.BUILDING"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'BUILDING', row, rowIndex)"
            />
          </template>
          <template #TELNR_LONG_edit="{row, rowIndex}">
            <el-input
              v-model="row.TELNR_LONG"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'TELNR_LONG', row, rowIndex)"
            />
          </template>
          <template #TEL_NUMBER_edit="{row, rowIndex}">
            <el-input
              v-model="row.TEL_NUMBER"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'TEL_NUMBER', row, rowIndex)"
            />
          </template>
          <template #FAX_NUMBER_edit="{row, rowIndex}">
            <el-input
              v-model="row.FAX_NUMBER"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'FAX_NUMBER', row, rowIndex)"
            />
          </template>
          <template #REGION_edit="{row}">
            <vxe-select
              v-model="row.REGION"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              transfer
              @change="changeRegion($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['province']"
                :key="selectItem.BLAND"
                :label="selectItem.BEZEI"
                :value="selectItem.BLAND"
              />
            </vxe-select>
          </template>
          <template #CITY_CODE_edit="{ row }">
            <vxe-select
              v-model="row.CITY_CODE"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              transfer
              type="text"
              @change="changeCity($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['city']"
                :key="selectItem.CITY_CODE"
                :label="selectItem.CITY_NAME"
                :value="selectItem.CITY_CODE"
              />
            </vxe-select>
          </template>
          <template #STREETCODE_edit="{ row }">
            <vxe-select
              v-model="row.STREETCODE"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              transfer
              @change="changeStreet($event, row)"
            >
              <vxe-option
                v-for="selectItem in selectDataOptions['street']"
                :key="selectItem.STRT_CODE"
                :label="selectItem.MC_STREET"
                :value="selectItem.STRT_CODE"
              />
            </vxe-select>
          </template>
          <template #STREET_edit="{row, rowIndex}">
            <el-input
              v-model="row.STREET"
              :disabled="!$_has(['WLYALL', 'WLY004'])"
              size="mini"
              @paste.native="pasteInput($event, 'STREET', row, rowIndex)"
            />
          </template>
          <!-- <template v-for="item in gridOptions3.columns" #[item.field]="{ row, rowIndex }">
            <div :key="item.field">
              <el-select
                v-if="item.field === 'ADR_KIND'"
                v-model="row[item.field]"
                :disabled="row.GUID ? true : false"
                size="mini"
                @change="addressTypeChange($event, row)"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['A0099']"
                  :key="selectItem.value"
                  :label="selectItem.name"
                  :value="selectItem.value"
                />
              </el-select>
              <el-select
                v-else-if="item.field === 'REGION'"
                v-model="row[item.field]"
                size="mini"
                :disabled="!$_has(['WLYALL', 'WLY004'])"
                @change="changeRegion($event, row)"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['province']"
                  :key="selectItem.BLAND"
                  :label="selectItem.BEZEI"
                  :value="selectItem.BLAND"
                />
              </el-select>

              <el-select
                v-else-if="item.field === 'CITY_CODE'"
                v-model="row[item.field]"
                size="mini"
                :disabled="!$_has(['WLYALL', 'WLY004'])"
                @change="changeCity($event, row)"
              >
                <el-option
                  v-for="selectItem in row['cityOptions']"
                  :key="selectItem.CITY_CODE"
                  :label="selectItem.CITY_NAME"
                  :value="selectItem.CITY_CODE"
                />
              </el-select>

              <el-select
                v-else-if="item.field === 'STREETCODE'"
                v-model="row[item.field]"
                :disabled="!$_has(['WLYALL', 'WLY004'])"
                size="mini"
              >
                <el-option
                  v-for="selectItem in row['streetOptions']"
                  :key="selectItem.STRT_CODE"
                  :label="selectItem.MC_STREET"
                  :value="selectItem.STRT_CODE"
                />
              </el-select>

              <el-input
                v-else-if="gridOptions3.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                :disabled="!$_has(['WLYALL', 'WLY004'])"
                placeholder="请输入"
                size="mini"
                @paste.native="pasteInput($event, item.field, row, rowIndex)"
              />
            </div>
          </template> -->
        </vxe-grid>
      </TableCommon>

      <!-- 可售产品 -->
      <TableCommon title="可售产品清单" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="增加" @click="insertKSList" />
          <table-button name="delete" tip="删除" @click="removeKSList" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="240"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <wly-input
                v-if="item.field === 'ZZFLD00001Z'"
                v-model="row[item.field]"
                input-type="product"
                @enter="handleEnterProduct(...arguments, row._X_ID)"
                @handleSuffixClick="openDialog($event, '产品选择', row._X_ID)"
              />
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <!-- 客户关系 -->
      <slot name="relation" />

      <!-- 客户角色 -->
      <slot name="role" />

      <!-- 发货审批 -->
      <TableCommon title="发货审批设置" :custome-config="() => vxeShowCustom('xTableApprove')">
        <template #button>
          <table-button name="save" tip="保存" @click="saveAP" />
        </template>
        <vxe-grid
          ref="xTableApprove"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsApprove.columns"
          :data="gridOptionsApprove.data"
        >
          <template v-for="item in gridOptionsApprove.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="item.field !== 'affairPlanPeopleName'"
                v-model="row[item.field]"
                size="mini"
                clearable
                @clear="clearApprove(item.field)"
                @focus="openDialog($event, '人员选择', item.field)"
              />
              <el-input
                v-else-if="item.field === 'affairPlanPeopleName' && row.byClient == 0"
                size="mini"
                :value="row[item.field]"
                @focus="showSaleApprove"
              />
              <el-input
                v-else-if="item.field === 'affairPlanPeopleName' && row.byClient == 1"
                v-model="row[item.field]"
                size="mini"
                clearable
                @clear="clearApprove(item.field)"
                @focus="openDialog($event, '人员选择', item.field)"
              />
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME || row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <!-- 历史变更 -->
      <TableCommon title="客户变更历史" :custome-config="() => vxeShowCustom('xTable2')">
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions2.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>

      <!-- 客户类型变更 -->
      <TableCommon title="客户类型变更记录" :custome-config="() => vxeShowCustom('xTable22')">
        <vxe-grid
          ref="xTable22"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsType.columns"
          :data="gridOptionsType.data"
        >
          <!-- <template #toolbar />
          <template v-for="item in gridOptionsType.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template> -->
        </vxe-grid>
      </TableCommon>

      <!-- 法人名称变更记录 -->
      <TableCommon title="法人名称变更记录" :custome-config="() => vxeShowCustom('xTableFrmc')">
        <vxe-grid
          ref="xTableFrmc"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFrmc.columns"
          :data="gridOptionsFrmc.data"
        />
      </TableCommon>

      <!-- 法人电话变更记录 -->
      <TableCommon title="法人电话变更记录" :custome-config="() => vxeShowCustom('xTableFrdh')">
        <vxe-grid
          ref="xTableFrdh"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFrdh.columns"
          :data="gridOptionsFrdh.data"
        />
      </TableCommon>

      <!-- 信用代码变更记录 -->
      <TableCommon title="信用代码变更记录" :custome-config="() => vxeShowCustom('xTableXydm')">
        <vxe-grid
          ref="xTableXydm"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsXydm.columns"
          :data="gridOptionsXydm.data"
        />
      </TableCommon>

      <!-- 发票类型变更记录 -->
      <TableCommon title="发票类型变更记录" :custome-config="() => vxeShowCustom('xTableFplx')">
        <vxe-grid
          ref="xTableFplx"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFplx.columns"
          :data="gridOptionsFplx.data"
        />
      </TableCommon>

      <!-- 税号变更记录 -->
      <TableCommon title="税号变更记录" :custome-config="() => vxeShowCustom('xTableSh')">
        <vxe-grid
          ref="xTableSh"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsSh.columns"
          :data="gridOptionsSh.data"
        />
      </TableCommon>

      <!-- 银行名称变更记录 -->
      <TableCommon title="银行名称变更记录" :custome-config="() => vxeShowCustom('xTableYhmc')">
        <vxe-grid
          ref="xTableYhmc"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsYhmc.columns"
          :data="gridOptionsYhmc.data"
        />
      </TableCommon>

      <!-- 银行账号变更记录 -->
      <TableCommon title="银行账号变更记录" :custome-config="() => vxeShowCustom('xTableYhzh')">
        <vxe-grid
          ref="xTableYhzh"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsYhzh.columns"
          :data="gridOptionsYhzh.data"
        />
      </TableCommon>

      <!-- 营销单元变更记录 -->
      <TableCommon title="营销单元变更记录" :custome-config="() => vxeShowCustom('xTableYxdy')">
        <vxe-grid
          ref="xTableYxdy"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="260"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsYxdyHistory.columns"
          :data="gridOptionsYxdyHistory.data"
        />
      </TableCommon>

    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
      destroy-on-close
    >
      <template v-if="dialogTitle === '客户选择'">
        <client-select ref="dialogSelect" />
      </template>
      <template v-if="dialogTitle === '人员选择'">
        <staff-select ref="dialogSelect" />
      </template>
      <template v-if="dialogTitle === '产品选择'">
        <product-select
          ref="dialogSelect"
          :query-params="{ isMdmClient: 1, mode: 'BP', yxdy: saleCenterGridOptions.data }"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
          >取消</el-button
        >
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showPrintDialog"
      title="地址打印浏览"
      width="70%"
      top="5vh"
    >
      <iframe :src="printUrl" frameborder="0" style="width: 100%;height: 600px" />
    </el-dialog>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="营销单元选择"
      :visible.sync="saleDialog"
      width="500px"
      :append-to-body="true"
    >
      <div v-if="saleDialog">
        <vxe-grid
          ref="saleSelect"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :columns="siginColumn"
          :data="customerInfo.yxdy"
        />
      </div>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="saleDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitType"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      title="上级客户选择"
      :visible.sync="showSuperiorClientDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showSuperiorClientDialog">
        <client-select ref="superiorClientSelect" />
      </template>
      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showSuperiorClientDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitSuperiorClient"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      title="曾用名选择"
      :visible.sync="showFormerClientDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showFormerClientDialog">
        <client-select ref="formerClientSelect" />
      </template>
      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-circle-close" @click="showFormerClientDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitFormerClient"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showComponentDialog"
      width="70%"
      append-to-body
      title="营销战区销售内勤审批人设置"
    >
      <vxe-grid
        ref="xTableApprove"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="auto"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: false }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="saleApproveGridOptions.columns"
        :data="saleApproveGridOptions.data"
      >
        <template v-for="item in saleApproveGridOptions.columns" #[item.field]="{ row }">
          <div :key="item.field">
            <el-input
              v-model="row[item.field]"
              size="mini"
              clearable
              @clear="clearSaleApprove(item.field, row)"
              @focus="openStaffDialog($event, '人员选择', item.field, row)"
            />
          </div>
        </template>
      </vxe-grid>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showComponentDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="subApprove"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import StaffSelect from '@/components/dialog/StaffSelect.vue'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { getArea, apiGetOrgOrBase } from '@/api/sap/common-sap'
import { printEMSAddress } from '@/api/sap/make-invoice-sap'
import { hexToBytes, frontExport, sapDownloadFile } from '@/utils/frontExport'
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'

import {
  apiSaveOrUpdateApprove,
  apiFindCustomerApprove,
  apiFindSaleManager,
  apiSaveSaleManagerByCenter
} from '@/api/client'
import { mapGetters } from 'vuex'
export default {
  components: { ProductSelect, StaffSelect, ClientSelect },
  props: {
    clientData: {
      type: Object,
      defualt: () => null
    }
  },
  data() {
    return {
      PARTNER: '',
      wlyClientPo: {},
      TAX: {},
      HISTORY: [],
      catchAreaList: [],
      catchCityList: [],
      isChangeCustome: 0,
      employeeControl: '',
      showDialog: false,
      saleDialog: false,
      showPrintDialog: false,
      dialogTitle: '客户选择',
      showComponentDialog: false,
      catchBase: {},
      showSuperiorClientDialog: false,
      showFormerClientDialog: false,
      superiorBpOriginalValue: '',
      formerBpOriginalValue: '',
      validRules: {
        ADR_KIND: [{ required: true, trigger: 'manual' }],
        REGION: [{ required: true, trigger: 'manual' }],
        CITY_CODE: [{ required: true, trigger: 'manual' }],
        STREETCODE: [{ required: true, trigger: 'manual' }],
        STREET: [{ required: true, trigger: 'manual' }]
      },
      siginColumn: [
        { type: 'radio', field: 'radio', title: '', width: 50 },
        { field: 'zzfld00001h', title: '营销单元编码', width: 120 },
        { field: 'mc_short', title: '营销单元描述' }
      ],
      gridOptionsApprove: {
        columns: [
          {
            field: 'channelManagerName',
            title: '渠道经理',
            slots: { default: 'channelManagerName' }
          },
          { field: 'baseManagerName', title: '基地总经理', slots: { default: 'baseManagerName' } },
          { field: 'areaManagerName', title: '战区总经理', slots: { default: 'areaManagerName' } },
          {
            field: 'affairPlanPeopleName',
            title: '销售内勤',
            slots: { default: 'affairPlanPeopleName' }
          },
          { field: 'datum', title: '最后更改日期' },
          { field: 'createdByName', title: '更改人' }
          /* { field: 'reservedName1', title: '预留人员1', slots: { default: 'reservedName1' }},
          { field: 'reservedName2', title: '预留人员2', slots: { default: 'reservedName2' }},
          { field: 'corePlanPeopleName', title: '预留人员3', slots: { default: 'corePlanPeopleName' }},
          { field: 'corePlanPeople2Name', title: '预留人员4', slots: { default: 'corePlanPeople2Name' }}*/
        ],
        data: [
          {
            customerCode: '',
            id: '',
            channelManager: '',
            channelManagerName: '',
            baseManager: '',
            baseManagerName: '',
            areaManager: '',
            areaManagerName: '',
            datum: '',
            corePlanPeople: '',
            corePlanPeopleName: '',
            corePlanPeople2: '',
            corePlanPeople2Name: '',
            affairPlanPeople: '',
            affairPlanPeopleName: '',
            reservedName1: '',
            reservedCode1: '',
            reservedCode2: '',
            reservedName2: ''
          }
        ]
      },
      // 营销单元
      saleCenterGridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'ZZFLD00001H', title: '营销单元', slots: { default: 'ZZFLD00001H' } },
          { field: 'ZZFLD00003E', title: '基地', slots: { default: 'ZZFLD00003E' } }
        ],
        data: []
      },
      // 可售产品
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'ZZFLD00001Z',
            title: '产品信息',
            width: 300,
            slots: { default: 'ZZFLD00001Z' }
          },
          { field: 'ZZFLD000020', title: '产品描述' }
        ],
        data: []
      },
      gridOptionsType: {
        columns: [
          // { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) },
          { field: 'ZZFLD000016', title: '客户类型编码', width: 160 },
          { field: 'ZZFLD000016_TEXT', title: '客户类型描述' }
        ],
        data: []
      },
      // 法人名称变更记录
      gridOptionsFrmc: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 法人电话变更记录
      gridOptionsFrdh: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 信用代码变更记录
      gridOptionsXydm: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 发票类型变更记录
      gridOptionsFplx: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 税号变更记录
      gridOptionsSh: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 银行名称变更记录
      gridOptionsYhmc: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 银行账号变更记录
      gridOptionsYhzh: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      gridOptionsYxdyHistory: {
        columns: [
          { field: 'CHANGE_NUMBER', title: '变更次数', width: 80 },
          { field: 'FIELD_NAME', title: '名称', width: 120 },
          { field: 'FIELD_VALUE', title: '内容', width: 200 },
          { field: 'CHANGIN_DATE', title: '变更日期', width: 160, formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CHANGIN_TIME', title: '变更时间', width: 160, formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      // 客户变更历史
      gridOptions2: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'C_DATUM1', title: '原始客户创建日期', width: 120 },
          { field: 'C_PAERTNER1', title: '原始客户编码', width: 120 },
          { field: 'C_PAERTNER1_D', title: '原始客户名称', width: 120 },
          {
            field: 'C_DATUM2',
            title: '第1次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER2', title: '第1次变更客户', width: 120 },
          { field: 'C_PAERTNER2_D', title: '第1次变更客户名称', width: 120 },
          {
            field: 'C_DATUM3',
            title: '第2次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER3', title: '第2次变更客户', width: 120 },
          { field: 'C_PAERTNER3_D', title: '第2次变更客户名称', width: 120 },
          {
            field: 'C_DATUM4',
            title: '第3次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER4', title: '第3次变更客户', width: 120 },
          { field: 'C_PAERTNER4_D', title: '第3次变更客户名称', width: 120 },
          {
            field: 'C_DATUM5',
            title: '第4次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER5', title: '第4次变更客户', width: 120 },
          { field: 'C_PAERTNER5_D', title: '第4次变更客户名称', width: 120 },
          {
            field: 'C_DATUM6',
            title: '第5次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER6', title: '第5次变更客户', width: 120 },
          { field: 'C_PAERTNER6_D', title: '第5次变更客户名称', width: 120 },
          {
            field: 'C_DATUM7',
            title: '第6次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER7', title: '第6次变更客户', width: 120 },
          { field: 'C_PAERTNER7_D', title: '第6次变更客户名称', width: 120 },
          {
            field: 'C_DATUM8',
            title: '第7次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER8', title: '第7次变更客户', width: 120 },
          { field: 'C_PAERTNER8_D', title: '第7次变更客户名称', width: 120 },
          {
            field: 'C_DATUM9',
            title: '第8次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER9', title: '第8次变更客户', width: 120 },
          { field: 'C_PAERTNER9_D', title: '第8次变更客户名称', width: 120 },
          {
            field: 'C_DATUM10',
            title: '第9次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER10', title: '第9次变更客户', width: 120 },
          { field: 'C_PAERTNER10_D', title: '第9次变更客户名称', width: 120 },
          {
            field: 'C_DATUM11',
            title: '第10次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER11', title: '第10次变更客户', width: 120 },
          { field: 'C_PAERTNER11_D', title: '第10次变更客户名称', width: 120 },
          {
            field: 'C_DATUM12',
            title: '第11次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER12', title: '第11次变更客户', width: 120 },
          { field: 'C_PAERTNER12_D', title: '第11次变更客户名称', width: 120 },
          {
            field: 'C_DATUM13',
            title: '第12次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER13', title: '第12次变更客户', width: 120 },
          { field: 'C_PAERTNER13_D', title: '第12次变更客户名称', width: 120 },
          {
            field: 'C_DATUM14',
            title: '第13次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER14', title: '第13次变更客户', width: 120 },
          { field: 'C_PAERTNER14_D', title: '第13次变更客户名称', width: 120 },
          {
            field: 'C_DATUM15',
            title: '第14次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER15', title: '第14次变更客户', width: 120 },
          { field: 'C_PAERTNER15_D', title: '第14次变更客户名称', width: 120 },
          {
            field: 'C_DATUM16',
            title: '第15次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER16', title: '第15次变更客户', width: 120 },
          { field: 'C_PAERTNER16_D', title: '第15次变更客户名称', width: 120 },
          {
            field: 'C_DATUM17',
            title: '第16次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER17', title: '第16次变更客户', width: 120 },
          { field: 'C_PAERTNER17_D', title: '第16次变更客户名称', width: 120 },
          {
            field: 'C_DATUM18',
            title: '第17次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER18', title: '第17次变更客户', width: 120 },
          { field: 'C_PAERTNER18_D', title: '第17次变更客户名称', width: 120 },
          {
            field: 'C_DATUM19',
            title: '第18次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER19', title: '第18次变更客户', width: 120 },
          { field: 'C_PAERTNER19_D', title: '第18次变更客户名称', width: 120 },
          {
            field: 'C_DATUM20',
            title: '第19次变更日期',
            width: 120,
            formatter: ({ cellValue }) => cellValue.replace('00000000', '')
          },
          { field: 'C_PAERTNER20', title: '第19次变更客户', width: 120 },
          { field: 'C_PAERTNER20_D', title: '第19次变更客户名称', width: 120 }
        ],
        data: []
      },
      // 地址信息
      gridOptions3: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'ADR_KIND',
            title: '地址类型',
            width: 100,
            slots: { default: 'ADR_KIND', edit: 'ADR_KIND_edit' },
            editRender: {}
          },
          {
            field: 'C_O_NAME',
            title: '联系人',
            width: 80,
            slots: { edit: 'C_O_NAME_edit' },
            editRender: {}
          },
          {
            field: 'BUILDING',
            title: '身份证号',
            width: 140,
            slots: { edit: 'BUILDING_edit' },
            editRender: {}
          },
          {
            field: 'TELNR_LONG',
            title: '电话',
            width: 100,
            slots: { edit: 'TELNR_LONG_edit' },
            editRender: {}
          },
          {
            field: 'TEL_NUMBER',
            title: '手机',
            width: 100,
            slots: { edit: 'TEL_NUMBER_edit' },
            editRender: {}
          },
          {
            field: 'FAX_NUMBER',
            title: '电子邮箱',
            width: 80,
            slots: { edit: 'FAX_NUMBER_edit' },
            editRender: {}
          },
          {
            field: 'REGION',
            title: '省',
            width: 80,
            slots: { default: 'REGION', edit: 'REGION_edit' },
            editRender: {}
          },
          {
            field: 'CITY_CODE',
            title: '市',
            width: 80,
            slots: { default: 'CITY_CODE', edit: 'CITY_CODE_edit' },
            editRender: {}
          },
          {
            field: 'STREETCODE',
            title: '区',
            width: 80,
            slots: { default: 'STREETCODE', edit: 'STREETCODE_edit' },
            editRender: {}
          },
          {
            field: 'STREET',
            title: '地址',
            width: 385,
            slots: { edit: 'STREET_edit' },
            editRender: {}
          }
        ],
        columnsFieldTypes: {
          ADR_KIND: 'select',
          C_O_NAME: 'input',
          BUILDING: 'input',
          TELNR_LONG: 'input',
          TEL_NUMBER: 'input',
          FAX_NUMBER: 'input',
          REGION: 'select',
          CITY_CODE: 'select',
          STREETCODE: 'select',
          STREET: 'input'
        },
        data: [],
        delData: []
      },
      currentSaleRow: null,
      saleApproveGridOptions: {
        columns: [
          { field: 'saleCenter', title: '营销战区编码', width: 160 },
          { field: 'saleCenterName', title: '营销战区名称', width: 160 },
          {
            field: 'saleManagerName',
            title: '销售内勤名称1',
            slots: { default: 'saleManagerName' }
          },
          {
            field: 'saleManagerName2',
            title: '销售内勤名称2',
            slots: { default: 'saleManagerName2' }
          },
          {
            field: 'saleManagerName3',
            title: '销售内勤名称3',
            slots: { default: 'saleManagerName3' }
          },
          { field: 'datum', title: '最后更改日期' },
          { field: 'createdByName', title: '更改人' }
        ],
        data: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'filename' } },
          { field: 'MIMETYPE', title: '附件类型', formatter: ({ row, cellValue }) => {
            const toTypeName = (val) => {
              if (!val) return ''
              const s = String(val).toLowerCase()
              if (s.includes('/')) return s.split('/').pop()
              if (s.includes('.')) return s.split('.').pop()
              return s
            }
            const t = cellValue || row.DOC_TYPE || row.doc_type
            if (t) return toTypeName(t)
            const name = row.FILENAME || row.filename || ''
            const idx = name.lastIndexOf('.')
            return idx > -1 ? name.slice(idx + 1).toLowerCase() : ''
          } },
          { field: 'FILELENGTH', title: '大小', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'CREATED_DATE', title: '上传日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CREATED_TIME', title: '上传时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: [],
        delData: []
      },
      ProductXID: '',
      addressRow: null,
      selectDataOptions: {
        province: [],
        street: [],
        city: [],
        orgList: [],
        A0085: []
      },
      printUrl: ''
    }
  },
  computed: {
    ...mapGetters(['customerInfo', 'role']),
    hasRole() {
      return this.role.USER_BP === '0008101022' || this.role.ROLE === 'WLY002' || this.role.ROLE === 'WLY008'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getInfo()
      this.getSelectDictDataOrigin('A0099')
      this.getSelectDictDataOrigin('A0019')
      this.getSelectDictDataOrigin('A0054')
      this.getSelectDictDataOrigin('A0064')
      this.getSelectDictDataOrigin('A0032')
      this.getSelectDictDataOrigin('A0009')
      this.getSelectDictDataOrigin('A0085')
      getArea('', 'region').then(res => {
        this.selectDataOptions.province = res.DATA
      })
      this.findWlyOrg()
    },
    exportAddressExcel() {
      const columns = [
        {
          field: 'ADR_KIND_TEXT',
          title: '地址类型',
          width: 100
        },
        {
          field: 'C_O_NAME',
          title: '联系人',
          width: 100
        },
        {
          field: 'BUILDING',
          title: '身份证号',
          width: 180
        },
        {
          field: 'TELNR_LONG',
          title: '电话',
          width: 180
        },
        {
          field: 'TEL_NUMBER',
          title: '手机',
          width: 120
        },
        {
          field: 'FAX_NUMBER',
          title: '电子邮箱',
          width: 120
        },
        {
          field: 'BEZEI',
          title: '省',
          width: 100
        },
        {
          field: 'CITY_NAME',
          title: '市',
          width: 140
        },
        {
          field: 'STREET_NAME',
          title: '区',
          width: 100
        },
        {
          field: 'STREET',
          title: '地址',
          width: 250
        }
      ]
      frontExport(columns, this.gridOptions3.data, '地址信息')
    },
    editActived({ column, row }) {
      if (column.property === 'CITY_CODE') {
        if (row.REGION) {
          getArea(row.REGION, 'city').then(res => {
            this.$set(this.selectDataOptions, 'city', res.DATA)
          })
        } else {
          this.selectDataOptions.city = []
        }
      } else if (column.property === 'STREETCODE') {
        if (row.CITY_CODE) {
          getArea(row.CITY_CODE, 'street').then(res => {
            this.$set(this.selectDataOptions, 'street', res.DATA)
          })
        } else {
          this.selectDataOptions.street = []
        }
      }
    },
    // 粘贴地址
    pasteInput(e, field, row, rowIndex) {
      const pasteFields = [
        'C_O_NAME',
        'BUILDING',
        'TELNR_LONG',
        'TEL_NUMBER',
        'FAX_NUMBER',
        'REGION',
        'CITY_CODE',
        'STREETCODE',
        'STREET'
      ]
      if ((e.clipboardData || window.clipboardData) && pasteFields.includes(field)) {
        const clipboardData = e.clipboardData || window.clipboardData
        if (clipboardData.getData('text').length) {
          const text = clipboardData.getData('text')
          // 拆分多少行
          const rows = text.split('\n')
          if (text.endsWith('\n')) {
            rows.splice(-1)
          }

          if (rows.length === 1) {
            this.handlePasteContent(rows[0], row, field)
          } else {
            rows.forEach((r, i) => {
              this.handlePasteContent(r, this.gridOptions3.data[i + rowIndex], field)
            })
          }
        }
      }
    },
    handlePasteContent(data, row, field) {
      const arr = data.split('\t')
      if (arr.length <= 1) return
      const pasteFields = [
        'C_O_NAME',
        'BUILDING',
        'TELNR_LONG',
        'TEL_NUMBER',
        'FAX_NUMBER',
        'REGION',
        'CITY_CODE',
        'STREETCODE',
        'STREET'
      ]
      const sIdx = pasteFields.indexOf(field)
      arr.forEach((item, i) => {
        const k = sIdx + i
        setTimeout(() => {
          if (pasteFields[k] === 'REGION') {
            row['BEZEI'] = arr[i]
          } else if (pasteFields[k] === 'CITY_CODE') {
            row['CITY_NAME'] = arr[i]
          } else if (pasteFields[k] === 'STREETCODE') {
            row['STREET_NAME'] = arr[i]
          }
          row[pasteFields[k]] = arr[i]
        }, 100)
      })
    },
    // 打印地址
    /**
     * 1. 先判断当前登录账号的营销单元有几个：只有一条，则直接传这个营销单元编码；有多条，需要在前端显示出来让选择。
     * 2. 判断客户的地址清单里 有没得 地址类型为 ZBMAIL_TO 的地址，没有则提示 ‘没有对应的发票邮寄地址，打印失败’
     */
    printAddress() {
      const address = this.gridOptions3.data.find(v => v.ADR_KIND === 'ZBMAIL_TO' && v.GUID)
      // 验证是否有收票地址
      if (!address) {
        return this.$message.error('没有对应的发票邮寄地址，打印失败')
      }
      if (this.customerInfo.yxdy.length > 1) {
        // 需要选择
        this.saleDialog = true
        return
      }
      const params = {
        mode: 'BP_ADDRESS',
        user_bp: this.role.USER_BP,
        name_org1: this.wlyClientPo.NAME_ORG1,
        sal_center: this.customerInfo.yxdy[0]?.zzfld00001h,
        address
      }
      this.generatorUrl(params)
    },
    submitType() {
      const data = this.$refs.saleSelect.getRadioRecord()
      if (!data) return
      const params = {
        mode: 'BP_ADDRESS',
        user_bp: this.role.USER_BP,
        name_org1: this.wlyClientPo.NAME_ORG1,
        sal_center: data.zzfld00001h,
        address: this.gridOptions3.data.find(v => v.ADR_KIND === 'ZBMAIL_TO' && v.GUID)
      }
      this.generatorUrl(params)
      this.saleDialog = false
    },
    // 生成打印地址url
    async generatorUrl(data) {
      const res = await printEMSAddress(data)
      if (res.msgtype === 'S') {
        this.showPrintDialog = true
        var uint8Array = new Uint8Array(hexToBytes(res.data))
        var blob = new Blob([uint8Array], { type: 'application/pdf' })
        this.printUrl = '/static/pdf/web/viewer.html?file=' + URL.createObjectURL(blob)
      } else {
        this.$message.error(res.message)
      }
    },
    // 保存要货审批人
    async saveAP() {
      try {
        const [data] = this.gridOptionsApprove.data
        data.customerName = this.wlyClientPo.NAME_ORG1
        const { status } = await apiSaveOrUpdateApprove(data)
        if (status != 2) {
          this.$message.success('保存成功！')
        }
      } catch (e) {
        this.$message.error('发货审批设置失败！')
        return
      }
    },
    handleEnterProduct(e, type, data, XID) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.ProductXID = XID

      switch (type) {
        case 'product':
          this.confirmProduct(data)
          break
      }
    },
    radioChange(e, type) {
      if (e === 'X') {
        const date = this.$utilsCommon.parseTime(new Date().getTime(), '{y}{m}{d}')
        if (type === 1) {
          this.wlyClientPo.ZZFLD000026_DATE = date
        } else {
          this.wlyClientPo.BLOCK_DATE = date
        }
      } else {
        if (type === 1) {
          this.wlyClientPo.ZZFLD000026_DATE = ''
          this.wlyClientPo.REMARK_GD = ''
        } else {
          this.wlyClientPo.BLOCK_DATE = ''
          this.wlyClientPo.REMARK_BLK = ''
        }
      }
    },
    // 地址类型改变
    addressTypeChange(e, row) {
      console.log('change了', e, row)
      if (e.value === 'BILL_TO') {
        const has = this.gridOptions3.data.filter(v => v.ADR_KIND === 'BILL_TO')
        if (has.length > 1) {
          row.ADR_KIND = ''
          row.ADR_KIND_TEXT = ''
          return this.$message.error('不能改为开票地址！')
        }
      }
      row['ADR_KIND_TEXT'] =
        this.selectDataOptions['A0099'].find(v => v.value === e.value)?.name || ''
    },
    async changeColums(e, row) {
      if (!e) return
      const { DATA } = await apiGetOrgOrBase(e, 2)
      this.$set(row, 'baseList', DATA)
    },
    // 获取组织机构
    async findWlyOrg() {
      const { DATA } = await apiGetOrgOrBase('', 1)
      this.selectDataOptions['orgList'] = DATA
      // this.saleCenterGridOptions.columnsFields.ZZFLD00001H.options = DATA
    },
    async changeRegion(e, row) {
      // 获取描述字段
      row.BEZEI = this.selectDataOptions.province.find(v => v.BLAND === e.value)?.BEZEI || ''
      row.CITY_CODE = ''
      row.CITY_NAME = ''
      row.STREETCODE = ''
      row.STREET_NAME = ''
      const { DATA } = await getArea(e.value, 'city')
      this.$set(this.selectDataOptions, 'city', DATA)
      this.$set(this.selectDataOptions, 'street', [])
    },
    async changeCity(e, row) {
      row.CITY_NAME =
        this.selectDataOptions.city.find(v => v.CITY_CODE === e.value)?.CITY_NAME || ''
      row.STREETCODE = ''
      row.STREET_NAME = ''
      const { DATA } = await getArea(e.value, 'street')
      this.$set(this.selectDataOptions, 'street', DATA)
    },
    changeStreet(e, row) {
      row.STREET_NAME =
        this.selectDataOptions.street.find(v => v.STRT_CODE === e.value)?.MC_STREET || ''
    },
    isBusinessLicenseAddress(row) {
      if (!row) return false
      const text = String(row.ADR_KIND_TEXT || '')
      return text.includes('营业执照')
    },
    clearSaleApprove(field, row) {
      this.currentSaleRow = row
      this.currentSaleRow[field.replace('Name', '')] = ''
    },
    openStaffDialog(e, title, field, row) {
      e.target.blur()
      this.dialogTitle = title
      this.employeeControl = field
      this.currentSaleRow = row
      this.showDialog = true
    },
    openDialog(e, title, option, ChannelXID = '') {
      e.target.blur()
      this.dialogTitle = title
      this.showDialog = true
      if (title === '人员选择') {
        this.employeeControl = option
        this.ChannelXID = ChannelXID
      } else if (title === '产品选择') {
        this.ProductXID = option
      } else if (title === '客户选择') {
        this.isChangeCustome = option
      }
    },
    async showSaleApprove(e) {
      e.target.blur()
      const params = this.saleCenterGridOptions.data.map(v => v.ZZFLD00001H)
      const { data } = await apiFindSaleManager(params)
      this.saleApproveGridOptions.data = data
      this.showComponentDialog = true
    },
    async subApprove() {
      const data = await apiSaveSaleManagerByCenter(this.saleApproveGridOptions.data)
      this.$message.success('设置成功！')
      const approve = await apiFindCustomerApprove({ customerCode: this.wlyClientPo.PARTNER })
      this.gridOptionsApprove.data = [approve.data || {}]
      this.showComponentDialog = false
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.dialogTitle === '人员选择') {
          if (this.showComponentDialog === true) {
            this.confirmSaleApprove(data)
          } else {
            this.confirmEmployeer(data)
          }
        } else if (this.dialogTitle === '客户选择') {
          this.confirmClient(data)
        } else if (this.dialogTitle === '产品选择') {
          this.confirmProduct(data)
        }
      }
    },
    // 确认销售内勤选择人员
    confirmSaleApprove(data) {
      this.currentSaleRow[this.employeeControl] = data.name
      this.currentSaleRow[this.employeeControl.replace('Name', '')] = data.code
      this.showDialog = false
    },
    // 确定选择产品
    async confirmProduct(data) {
      const index = this.gridOptions.data.findIndex(v => v._X_ID === this.ProductXID)

      this.gridOptions.data.splice(index, 1, {
        ZZFLD00001Z: data.productCode,
        ZZFLD000020: data.description
      })
      this.showDialog = false
    },
    handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.wlyClientPo.ZZFLD00001D = data.customerCode
      this.wlyClientPo.NAME_ORG2 = data.name_org1
    },
    // 获取详情
    async getInfo() {
      const DATA = this.clientData
      this.gridOptionsApprove.data = [DATA.approve]
      // 客户基本信息
      this.wlyClientPo = DATA.INFO
      this.superiorBpOriginalValue = this.wlyClientPo.SUPERIOR_BP || ''
      this.formerBpOriginalValue = this.wlyClientPo.FORMER_BP || ''
      // 开票信息
      this.TAX = DATA.TAX
      // 营销中心
      this.saleCenterGridOptions.data = DATA.YXDY
      // 地址信息
      this.gridOptions3.data = DATA.ADDRESS
      // 变更信息
      this.gridOptions2.data = [DATA.HISTORY]
      // this.filterChangeInfo(DATA.HISTORY)
      this.HISTORY = DATA.HISTORY
      // 客户类型变更记录
      this.gridOptionsType.data = DATA.TYPE_HISTORY || []
      // 法人名称变更记录
      this.gridOptionsFrmc.data = DATA.FRMC_HISTORY || []
      // 法人电话变更记录
      this.gridOptionsFrdh.data = DATA.FRDH_HISTORY || []
      // 信用代码变更记录
      this.gridOptionsXydm.data = DATA.XYDM_HISTORY || []
      // 发票类型变更记录
      this.gridOptionsFplx.data = DATA.FPLX_HISTORY || []
      // 税号变更记录
      this.gridOptionsSh.data = DATA.SH_HISTORY || []
      // 银行名称变更记录
      this.gridOptionsYhmc.data = DATA.YHMC_HISTORY || []
      // 银行账号变更记录
      this.gridOptionsYhzh.data = DATA.YHZH_HISTORY || []

      // 营销单元变更记录
      this.gridOptionsYxdyHistory.data = DATA.YXDY_HISTORY || []

      // 可售产品清单
      this.gridOptions.data = DATA.PRO
      this.gridOptionsFile.data = DATA.ATTACHMENT || []

      this.gridOptionsApprove.data[0].customerCode = this.wlyClientPo.PARTNER

      this.$nextTick(() => {
        this.initSaleRow()
      })
    },
    // 初始化营销单元的行选项
    async initSaleRow() {
      for (const row of this.saleCenterGridOptions.data) {
        const { DATA } = await apiGetOrgOrBase(row.ZZFLD00001H, 2)
        this.$set(row, 'baseList', DATA)
      }
    },
    // 确认客户选择
    async confirmClient(data) {
      this.wlyClientPo.ZZFLD00001D = data.partner
      this.wlyClientPo.NAME_ORG2 = data.customerName
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 新增营销单元
    insertSaleCenter() {
      const data = {
        ZZFLD00001H: '',
        ZZFLD00003E: '',
        baseList: []
      }
      this.saleCenterGridOptions.data.unshift(data)
    },
    // 删除营销单元
    removeSaleCenter() {
      const checkedList = this.$refs.xTableSaleCenter.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.saleCenterGridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.saleCenterGridOptions.data.splice(index, 1)
      })
    },
    // 新增可售清单
    insertKSList() {
      const data = {
        productInfo: '',
        productDesc: ''
      }
      // this.$refs.xTable.insert(data)
      this.gridOptions.data.unshift(data)
    },
    // 删除可售清单
    removeKSList() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    // 验证信息
    validateAddress() {
      try {
        const keys = Object.keys(this.validRules)

        this.gridOptions3.data.forEach((row, i) => {
          for (const key of keys) {
            if (!row[key]) {
              throw new Error('请输入地址信息必输项！')
            }
          }
          if (this.isBusinessLicenseAddress(row) && !row.STREET) {
            throw new Error(`地址信息:第${i + 1}行营业执照地址需填写详细地址！`)
          }
          const regCard = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
          if (row.BUILDING && !regCard.test(row.BUILDING)) {
            throw new Error(`地址信息:第${i + 1}行` + '身份证格式不正确！')
          }
          const regPhone = /^1[3|4|5|7|8][0-9]{9}$/
          if (row.TEL_NUMBER && !regPhone.test(row.TEL_NUMBER)) {
            throw new Error(`地址信息:第${i + 1}行` + '手机号格式不正确！')
          }
          const regTel = /^(\d{3,4}-)?[0-9]{7,8}$/
          if (row.TELNR_LONG && !regTel.test(row.TELNR_LONG)) {
            throw new Error(`地址信息:第${i + 1}行` + '电话号格式不正确！')
          }
        })
        return true
      } catch (e) {
        this.$message.error(e.message)
        return false
      }
    },
    submitForm() {
      const result = {
        approve: this.gridOptionsApprove.data[0],
        INFO: this.wlyClientPo, // 基本信息
        YXDY: this.saleCenterGridOptions.data, // 营销单元
        PRO: this.gridOptions.data, // 可售产品清单
        HISTORY: this.HISTORY, // 历史变更
        ADDRESS: this.gridOptions3.data, // 地址信息
        ADDRESS_D: this.gridOptions3.delData,
        TAX: this.TAX, // 开票信息
        ATTACHMENT: this.gridOptionsFile.data.concat(this.gridOptionsFile.delData)
      }
      return result
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }
        strArr = strArr.join('')
        const dateTime = new Date().getTime()
        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type.toLowerCase(),
          DOC_TYPE: file.raw.type.toLowerCase(),
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.USER_BP,
          uname_text: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }
        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
      this.gridOptionsFile.delData = this.gridOptionsFile.delData.concat(checkedList.filter(v => v.GUID))
    },
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT || row.xcontent, row.FILENAME || row.filename)
    },
    // 新增地址信息
    insertAddressList() {
      const columns = this.gridOptions3.columns.filter(v => !v.type)
      const data = {}
      columns.forEach(v => (data[v.field] = ''))
      data.cityOptions = []
      data.streetOptions = []
      this.gridOptions3.data.unshift(data)
    },
    // 删除地址信息
    async removeAddressList() {
      const checkedList = this.$refs.xTable3.getCheckboxRecords()
      if (checkedList.some(item => item.ADR_KIND === 'BILL_TO' && item.GUID)) {
        return this.$message.warning('开票地址不能删除！')
      }
      const hasGuids = checkedList.filter(v => v.GUID)

      this.gridOptions3.delData = hasGuids
      checkedList.forEach(item => {
        const index = this.gridOptions3.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions3.data.splice(index, 1)
      })
    },
    clearApprove(field) {
      switch (field) {
        case 'channelManagerName':
          this.gridOptionsApprove.data[0].channelManager = ''
          break
        case 'baseManagerName':
          this.gridOptionsApprove.data[0].baseManager = ''
          break
        case 'areaManagerName':
          this.gridOptionsApprove.data[0].areaManager = ''
          break
        case 'corePlanPeopleName':
          this.gridOptionsApprove.data[0].corePlanPeople = ''
          break
        case 'corePlanPeople2Name':
          this.gridOptionsApprove.data[0].corePlanPeople2 = ''
          break
        case 'affairPlanPeopleName':
          this.gridOptionsApprove.data[0].affairPlanPeople = ''
          break
        case 'reservedName1':
          this.gridOptionsApprove.data[0].reservedCode1 = ''
          break
        case 'reservedName2':
          this.gridOptionsApprove.data[0].reservedCode2 = ''
          break
      }
    },
    openSuperiorClientDialog(event) {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      const currentValue = this.wlyClientPo.SUPERIOR_BP || ''
      this.superiorBpOriginalValue = currentValue
      this.showSuperiorClientDialog = true
    },
    submitSuperiorClient() {
      this.$refs.superiorClientSelect.submitForm().then(res => {
        if (res) {
          this.wlyClientPo.SUPERIOR_BP = res.partner
          this.wlyClientPo.SUPERIOR_BP_NAME = res.name_org1
          this.superiorBpOriginalValue = res.partner
          this.showSuperiorClientDialog = false
        }
      })
    },
    handleSuperiorClientKeydown(event) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Escape']
      if (event.ctrlKey || event.metaKey) {
        return
      }
      if (!allowedKeys.includes(event.key) && !event.key.startsWith('F')) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    handleSuperiorClientClear() {
      this.$set(this.wlyClientPo, 'SUPERIOR_BP_NAME', '')
      this.superiorBpOriginalValue = ''
      this.$set(this.wlyClientPo, 'SUPERIOR_BP', '')
      this.$forceUpdate()
    },
    handleSuperiorClientInput(value) {
      if (!value || value === '') {
        this.$set(this.wlyClientPo, 'SUPERIOR_BP_NAME', '')
        this.superiorBpOriginalValue = ''
        if (this.wlyClientPo.SUPERIOR_BP !== '') {
          this.$set(this.wlyClientPo, 'SUPERIOR_BP', '')
        }
        return
      }
      const currentValue = String(value || '')
      const originalValue = String(this.superiorBpOriginalValue || '')
      if (currentValue !== '' && currentValue !== originalValue && originalValue !== '') {
        this.$nextTick(() => {
          if (this.wlyClientPo.SUPERIOR_BP !== originalValue) {
            this.wlyClientPo.SUPERIOR_BP = originalValue
          }
        })
        return
      }
      if (currentValue === originalValue || originalValue === '') {
        this.superiorBpOriginalValue = currentValue
      }
    },
    handleSuperiorClientEnter(e, type, data) {
      if (typeof type === 'object') {
        this.$message.error(type.message)
        return
      }
      if (!data) return
      this.wlyClientPo.SUPERIOR_BP = data.partner
      this.wlyClientPo.SUPERIOR_BP_NAME = data.name_org1
      this.superiorBpOriginalValue = data.partner
    },
    openFormerClientDialog(event) {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      const currentValue = this.wlyClientPo.FORMER_BP || ''
      this.formerBpOriginalValue = currentValue
      this.showFormerClientDialog = true
    },
    submitFormerClient() {
      this.$refs.formerClientSelect.submitForm().then(res => {
        if (res) {
          this.wlyClientPo.FORMER_BP = res.partner
          this.wlyClientPo.FORMER_BP_NAME = res.name_org1
          this.formerBpOriginalValue = res.partner
          this.showFormerClientDialog = false
        }
      })
    },
    handleFormerClientKeydown(event) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Escape']
      if (event.ctrlKey || event.metaKey) {
        return
      }
      if (!allowedKeys.includes(event.key) && !event.key.startsWith('F')) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    handleFormerClientClear() {
      this.$set(this.wlyClientPo, 'FORMER_BP_NAME', '')
      this.formerBpOriginalValue = ''
      this.$set(this.wlyClientPo, 'FORMER_BP', '')
      this.$forceUpdate()
    },
    handleFormerClientInput(value) {
      if (!value || value === '') {
        this.$set(this.wlyClientPo, 'FORMER_BP_NAME', '')
        this.formerBpOriginalValue = ''
        if (this.wlyClientPo.FORMER_BP !== '') {
          this.$set(this.wlyClientPo, 'FORMER_BP', '')
        }
        return
      }
      const currentValue = String(value || '')
      const originalValue = String(this.formerBpOriginalValue || '')
      if (currentValue !== '' && currentValue !== originalValue && originalValue !== '') {
        this.$nextTick(() => {
          if (this.wlyClientPo.FORMER_BP !== originalValue) {
            this.wlyClientPo.FORMER_BP = originalValue
          }
        })
        return
      }
      if (currentValue === originalValue || originalValue === '') {
        this.formerBpOriginalValue = currentValue
      }
    },
    handleFormerClientEnter(e, type, data) {
      if (typeof type === 'object') {
        this.$message.error(type.message)
        return
      }
      if (!data) return
      this.wlyClientPo.FORMER_BP = data.partner
      this.wlyClientPo.FORMER_BP_NAME = data.name_org1
      this.formerBpOriginalValue = data.partner
    },
    // 确认人员选择
    async confirmEmployeer(data) {
      console.log(data, '======')
      switch (this.employeeControl) {
        case 'channelManagerName':
          this.gridOptionsApprove.data[0].channelManagerName = data.name
          this.gridOptionsApprove.data[0].channelManager = data.code
          break
        case 'baseManagerName':
          this.gridOptionsApprove.data[0].baseManagerName = data.name
          this.gridOptionsApprove.data[0].baseManager = data.code
          break
        case 'areaManagerName':
          this.gridOptionsApprove.data[0].areaManagerName = data.name
          this.gridOptionsApprove.data[0].areaManager = data.code
          break
        case 'corePlanPeopleName':
          this.gridOptionsApprove.data[0].corePlanPeopleName = data.name
          this.gridOptionsApprove.data[0].corePlanPeople = data.code
          break
        case 'corePlanPeople2Name':
          this.gridOptionsApprove.data[0].corePlanPeople2Name = data.name
          this.gridOptionsApprove.data[0].corePlanPeople2 = data.code
          break
        case 'affairPlanPeopleName':
          this.gridOptionsApprove.data[0].affairPlanPeopleName = data.name
          this.gridOptionsApprove.data[0].affairPlanPeople = data.code
          break
        case 'reservedName1':
          this.gridOptionsApprove.data[0].reservedName1 = data.name
          this.gridOptionsApprove.data[0].reservedCode1 = data.code
          break
        case 'reservedName2':
          this.gridOptionsApprove.data[0].reservedName2 = data.name
          this.gridOptionsApprove.data[0].reservedCode2 = data.code
          break
      }
      this.showDialog = false
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}-{m}-{d}')
    }
  }
}
</script>

<style lang="scss" scoped>
.common-title {
  margin-top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/BaseInfo.vue